<template>
  <div class="flex flex-wrap gap-[8px] grow">
    <nested-dropdown
      ref="filterDropdown"
      size="sm"
      toggle-class="text-decoration-none toggle-custom button-primary rounded-lg py-[7px] px-1"
    >
      <template #toggle>
        <i class="k-filter-search text-[24px]" />
      </template>
      <template #header>
        <div class="p-[16px] pt-[9px] border-b-[1px] border-[#E2E2E2] text-[#000000] font-semibold">
          Filter
        </div>
      </template>
      <nested-dropdown-submenu
        ref="categorySubmenu"
        label="Status"
        menu-class="!min-w-[200px] !py-0"
        :toggle-class="`!rounded-none text-left !text-[#000000] !font-medium !px-[16px] !py-[12px]${status === 'semua' ? ' !bg-[#FCD4BE]' : ''}`"
      >
        <b-dropdown-item
          v-for="item in statusOptions"
          :key="item.value"
          :class="{ '!bg-[#FCD4BE] [&>a]:!text-[#F95031]': item.value === status }"
          @click="handleSortChange(item.value)"
        >
          {{ item.label }}
        </b-dropdown-item>
      </nested-dropdown-submenu>
      <b-button
        variant="ghost"
        size="sm"
        class="!text-[#E31A1A] !font-normal text-[12px] !px-[16px] !py-[7px] -mb-[7px] !rounded-none !rounded-b-[4px] !w-full !border-none text-left hover:bg-[#FCD4BE]"
        @click="handleSortChange()"
      >
        Reset Filter
      </b-button>
    </nested-dropdown>
    <div
      class="flex items-center rounded-[8px] h-[43.5px] overflow-hidden !border border-[#e2e2e2] has-[:focus]:border-[#f95031] w-full max-w-[320px]"
    >
      <i
        class="k-search-normal-1 ml-[12px] text-[24px] cursor-pointer"
        @click="$refs.search.focus()"
      />
      <b-form-input
        ref="search"
        v-model="keyword"
        type="search"
        placeholder="Cari nama, username TikTok atau no HP"
        class="border-0 shadow-none !text-[14px]"
        size="lg"
        :debounce="DEBOUNCED_CHANGE_TIMEOUT"
      />
    </div>
  </div>
</template>

<script>
import { NestedDropdown, NestedDropdownSubmenu } from '@core/components/nested-dropdown'
import { CAMPAIGN_DETAIL_FILTER_STATUS, ONGOING_CAMPAIGN_DETAIL_FILTER_STATUS } from '../config'

export default {
  name: 'FilterComponent',
  components: {
    NestedDropdown,
    NestedDropdownSubmenu,
  },
  props: {
    phase: {
      type: String,
      default: 'pre_campaign',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const { status, keyword } = this.$route.query
    return {
      status,
      keyword,
    }
  },
  computed: {
    statusOptions() {
      if (this.phase) {
        return this.phase === 'ongoing' ? ONGOING_CAMPAIGN_DETAIL_FILTER_STATUS : CAMPAIGN_DETAIL_FILTER_STATUS
      }
      if (this.$route.query.tab === 'ongoing') {
        return ONGOING_CAMPAIGN_DETAIL_FILTER_STATUS
      }
      return CAMPAIGN_DETAIL_FILTER_STATUS
    },
    generateQueryParam() {
      const { keyword, status } = this
      const query = {}
      if (keyword) query.keyword = keyword
      if (status) query.status = status
      return query
    },
  },
  watch: {
    keyword() {
      this.triggerFilterChange()
    },
    phase() {
      if (this.status) {
        const validValues = this.statusOptions.map(o => o.value)
        if (!validValues.includes(this.status)) {
          this.status = undefined
          this.triggerFilterChange()
        }
      }
    },
  },
  created() {
    this.DEBOUNCED_CHANGE_TIMEOUT = 500
  },
  beforeDestroy() {
    if (this.debouncedCategoryChange) {
      this.debouncedCategoryChange.cancel()
    }
  },
  methods: {
    handleSortChange(value) {
      this.status = value
      this.triggerFilterChange()
      this.$refs.filterDropdown.close()
    },
    emitChange() {
      this.$emit('change', {
        keyword: this.keyword,
        status: this.status,
      })
    },
    updateQueryParam() {
      const query = {
        ...this.$route.query,
        keyword: this.keyword || undefined,
        status: this.status || undefined,
      }
      if (_.isEqual(query, this.$route.query)) return
      this.$router.replace({ query }).catch(() => { })
    },
    triggerFilterChange() {
      this.updateQueryParam()
      this.emitChange()
    },
    resetAll() {
      this.keyword = undefined
      this.status = undefined
      this.triggerFilterChange()
      this.$refs.filterDropdown.close()
    },
  },
}
</script>
